function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getProductTypeById, getProductName, getPeriodPerformance } from '@finect/front-resources/Products';
import { getProductCommercializations, getUniqueOrganizations } from './products';
import { sha256 } from './sha256';
export var isAdviser = function isAdviser(author) {
  var _author$organizations = author.organizations,
    organizations = _author$organizations === void 0 ? [] : _author$organizations;
  return Boolean(organizations.find(function (organization) {
    return (organization.roles || []).includes('adviser');
  }));
};
export var contextualizeTag = function contextualizeTag(tag) {
  return {
    id: tag.id,
    alias: tag.alias,
    name: tag.name,
    window: tag.window
  };
};
export var contextualizeAuthor = function contextualizeAuthor(author) {
  return {
    id: author.id,
    alias: author.alias,
    displayName: author.displayName,
    type: author.subtype,
    isAdviser: isAdviser(author),
    isProfessional: author.isProfessional
  };
};
export var modelizeOrganization = function modelizeOrganization(_ref) {
  var id = _ref.id,
    alias = _ref.alias,
    displayName = _ref.displayName,
    subtype = _ref.subtype;
  return {
    id: id,
    alias: alias,
    displayName: displayName,
    subtype: subtype
  };
};
export var contextualizeProductCommercializations = function contextualizeProductCommercializations(product) {
  var managersCommercializations = getProductCommercializations(product.commercializations, 'manager');
  var distributorsCommercializations = getProductCommercializations(product.commercializations, 'distributor');
  return {
    managers: getUniqueOrganizations(managersCommercializations).map(modelizeOrganization),
    distributors: getUniqueOrganizations(distributorsCommercializations).map(modelizeOrganization)
  };
};
export var contextualizeFund = function contextualizeFund(fund) {
  var m12 = getPeriodPerformance(fund.stats, 'M12', 'accumulated');
  var commercializationOrganizations = contextualizeProductCommercializations(fund);
  return _objectSpread({
    id: fund.id,
    name: fund.type === 'plan' ? fund.class.name : fund.name,
    type: fund.subtype,
    alias: fund.alias,
    managementCompany: fund.managementCompany,
    regulatoryAuthorityId: fund.isin,
    srri: fund.srri,
    tags: fund.socialStats.tags.map(function (tag) {
      return contextualizeTag(tag);
    }),
    performance: {
      m12: m12 ? m12.value : null
    }
  }, commercializationOrganizations);
};
export var contextualizeProduct = function contextualizeProduct(_ref2) {
  var entity = _ref2.entity,
    subtype = _ref2.subtype;
  var commercializationOrganizations = contextualizeProductCommercializations(entity);
  return _objectSpread({
    id: entity.id,
    name: entity.name,
    type: subtype,
    alias: entity.alias,
    tags: entity.socialStats.tags.map(function (tag) {
      return contextualizeTag(tag);
    })
  }, commercializationOrganizations);
};
export var modelizeProduct = function modelizeProduct(_ref3) {
  var entity = _ref3.entity,
    subtype = _ref3.subtype;
  var commercializationOrganizations = contextualizeProductCommercializations(entity);
  return _objectSpread({
    id: entity.id,
    name: getProductName(entity, getProductTypeById(subtype)),
    category: subtype,
    alias: entity.alias
  }, commercializationOrganizations);
};
export var modelizeReview = function modelizeReview(review) {
  return {
    id: review.id,
    title: review.title,
    score: review.score,
    author: contextualizeAuthor(review.author)
  };
};
export var contextualizePill = function contextualizePill(pill) {
  return {
    id: pill.id,
    title: pill.title,
    partner: pill.partner,
    sessionId: pill.session ? pill.session.id : null,
    tags: pill.socialStats.tags.map(function (tag) {
      return contextualizeTag(tag);
    })
  };
};
export var contextualizeArticle = function contextualizeArticle(article) {
  return {
    id: article.id,
    title: article.title,
    author: contextualizeAuthor(article.author),
    forProfessionals: article.forProfessionals,
    evergreen: article.evergreen,
    revision: article.revision,
    type: article.type,
    tags: article.socialStats.tags.map(function (tag) {
      return contextualizeTag(tag);
    }),
    stats: {
      comments: article.stats.comments,
      subscribers: article.socialStats.subscribers,
      likes: article.socialStats.likes
    },
    targeting: article.author ? {
      authorId: article.author.id,
      authorSubtype: article.author.subtype,
      authorAlias: article.author.alias
    } : {}
  };
};
export var contextualizeStorefront = function contextualizeStorefront(storefront) {
  return {
    id: storefront.id,
    alias: storefront.alias,
    description: storefront.summary || storefront.description,
    summary: storefront.summary,
    title: storefront.title,
    name: storefront.name,
    tags: storefront.stats.tags.map(function (tag) {
      return contextualizeTag(tag);
    }),
    stats: {
      subscribers: storefront.stats.subscribers
    }
  };
};
export var contextualizeAggregations = function contextualizeAggregations(aggregations) {
  return aggregations.map(function (aggregation) {
    return {
      name: aggregation.name,
      status: aggregation.status
    };
  });
};
export var contextualizeLoggedInUser = function contextualizeLoggedInUser(user) {
  if (user && user.loggedIn) {
    return {
      loggedIn: true,
      id: user.id,
      type: user.subtype,
      isAdviser: user.isAdviser,
      isProfessional: user.isProfessional,
      email: sha256(user.email),
      stats: user.stats,
      aggregations: contextualizeAggregations(user.aggregations),
      risk: user.risk
    };
  }
  return {
    loggedIn: false
  };
};
export var contextualizeQuestion = function contextualizeQuestion(question) {
  var author = question.authors[question.author];
  return {
    title: question.title,
    answers: question.answers.map(function (_ref4) {
      var id = _ref4.id,
        answerAuthor = _ref4.author;
      return {
        id: id,
        author: {
          id: answerAuthor.id,
          alias: answerAuthor.alias,
          displayName: answerAuthor.name,
          type: 'user',
          isAdviser: Boolean(answerAuthor.adviserAt),
          isProfessional: false
        }
      };
    }),
    author: author ? {
      id: author.id,
      alias: author.alias,
      type: author.type,
      displayName: author.name,
      isAdviser: Boolean(author.adviserAt),
      isProfessional: false
    } : null,
    tags: question.tags.map(function (tag) {
      return {
        id: tag.id,
        alias: tag.description,
        name: tag.name
      };
    })
  };
};